module.exports = __webpack_public_path__ + "img/TOC_reviewIcon.773c1512.png";